import { Link } from 'react-router-dom';
import { Sparkles, ArrowLeft } from 'lucide-react';

export default function ComingSoonPage({ title, description, icon: Icon, color = 'bg-fuchsia-500', features = [] }) {
  return (
    <div className="mx-auto max-w-3xl py-10" data-testid={`coming-soon-${title.toLowerCase().replace(/\s+/g, '-')}`}>
      <Link to="/app" className="mb-6 inline-flex items-center gap-1 text-sm font-bold text-slate-500 hover:text-slate-900">
        <ArrowLeft className="h-4 w-4" /> Volver al inicio
      </Link>
      <div className="overflow-hidden rounded-3xl bg-gradient-to-br from-cnib-navy via-cnib-blue to-cnib-navy p-8 text-white shadow-2xl md:p-12">
        <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.3em] text-orange-400">
          <Sparkles className="h-4 w-4" /> Próximamente
        </div>
        <div className="mt-6 flex items-start gap-5">
          {Icon && (
            <span className={`flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl ${color} shadow-xl`}>
              <Icon className="h-8 w-8 text-white" />
            </span>
          )}
          <div className="min-w-0 flex-1">
            <h1 className="font-heading text-3xl font-extrabold leading-tight sm:text-4xl">{title}</h1>
            <p className="mt-3 text-sm leading-relaxed text-slate-200 sm:text-base">{description}</p>
          </div>
        </div>
        {features.length > 0 && (
          <div className="mt-8 grid gap-3 sm:grid-cols-2">
            {features.map((f, i) => (
              <div key={i} className="rounded-2xl bg-white/10 p-4 ring-1 ring-white/15 backdrop-blur">
                <p className="text-sm font-bold text-white">{f.title}</p>
                <p className="mt-1 text-xs text-slate-300">{f.text}</p>
              </div>
            ))}
          </div>
        )}
        <div className="mt-10 flex flex-wrap items-center gap-3 border-t border-white/10 pt-6">
          <span className="rounded-full bg-amber-500/20 px-3 py-1 text-xs font-bold text-amber-300">En construcción</span>
          <p className="text-xs text-slate-300">Estamos trabajando para habilitarlo pronto. Si quieres ser de los primeros en probarlo, escríbenos.</p>
        </div>
      </div>
    </div>
  );
}
